import React, { useState } from "react";
import { motion } from "framer-motion";

const tabGroups = {
  "🎓 Learning": [
    "📖 Cultural Books",
    "🎧 Folk Songs",
    "🎥 Documentaries",
    "🕯️ Rituals & Meanings",
    "🧘 DeepThinking RCA",
    "🏺 Festival History",
    "👩‍🏫 Quizzes & Games",
    "🗓️ Festival Calendar",
  ],
  "💰 Earning": [
    "💸 Share & Earn",
    "👨‍🏫 Culture Tutor",
    "🎁 Sell Crafts",
    "🧾 Coupons",
    "💼 Volunteer Jobs",
    "🛒 Marketplace",
  ],
  "🎊 Events": [
    "🎯 Planning Board",
    "🎟️ Venue Pass",
    "🧍 Visitor Card",
    "📱 QR Check-In",
    "🕰️ Countdown",
    "🗺️ Venue Map",
    "🪩 Themes",
  ],
  "👨‍👩‍👧 Community": [
    "💬 Discussions",
    "📢 Announcements",
    "🧑‍🤝 Groups",
    "🌍 Share Moments",
    "💖 Thanks Board",
    "🗳️ Polling",
    "🪔 Challenges",
  ],
  "💌 Invitations": [
    "💌 Invites",
    "🥳 E-Cards",
    "📷 Gallery",
    "📹 Videos",
    "💬 Wishes Wall",
  ],
  "🚗 Logistics": [
    "🏨 RoomAnywhere",
    "🪑 Venue Decor",
    "🍲 Catering",
    "🚗 Parking",
    "🏮 Utilities",
    "🧭 Navigation",
    "📍 Nearby Services",
  ],
  "🚨 Safety": [
    "🆘 SOS",
    "🚑 Emergency",
    "📞 Helplines",
    "👮 Security",
    "🔔 Alerts",
  ],
  "📊 Analytics": [
    "⭐ Feedback",
    "📈 Insights",
    "🧮 Expenses",
    "💰 Budget Tracker",
  ],
};

const FestifyHome = () => {
  const [activeTab, setActiveTab] = useState("🎓 Learning");

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100 flex flex-col">
      <header className="text-center py-4 border-b border-gray-700">
        <h1 className="text-2xl font-bold text-yellow-400">🎉 Festify</h1>
        <p className="text-sm text-gray-400">
          Celebrate. Connect. Create Memories.
        </p>
      </header>

      {/* Tabs */}
      <div className="flex overflow-x-auto no-scrollbar bg-gray-800 p-2">
        {Object.keys(tabGroups).map((tab) => (
          <button
            key={tab}
            className={`px-3 py-2 mx-1 rounded-lg text-sm ${
              activeTab === tab
                ? "bg-yellow-500 text-black font-semibold"
                : "bg-gray-700 text-gray-300"
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Grid Section */}
      <motion.div
        className="grid grid-cols-2 sm:grid-cols-3 gap-4 p-4 flex-grow"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        {tabGroups[activeTab].map((item) => (
          <motion.div
            key={item}
            className="bg-gray-800 p-4 rounded-2xl shadow-md hover:bg-yellow-500 hover:text-black text-center transition-all cursor-pointer"
            whileTap={{ scale: 0.95 }}
          >
            <p className="text-lg font-medium">{item}</p>
          </motion.div>
        ))}
      </motion.div>

      <footer className="text-center py-3 border-t border-gray-700 text-gray-500 text-xs">
        © 2025 Festify by Think5Whys Global DeepTech Solutions
      </footer>
    </div>
  );
};

export default FestifyHome;
